import { ModalBody, ModalBodyProps } from '@chakra-ui/react';
import type { FC } from 'react';
export type QModalBodyProps = ModalBodyProps;

export const QModalBody: FC<QModalBodyProps> = (props) => {
  return <ModalBody {...props} />;
};

QModalBody.displayName = 'QModalBody';
